<template>
  <edit-modal
    :is-show-dialog="isShowDialog"
    :action-label="actionLabel"
    :title="dialogTitle"
    @on-close="onClose"
    @on-action="onAction"
  >
    <v-overlay
      :absolute="true"
      :value="isModalLoading"
    >
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </v-overlay>
    <v-form
      ref="form"
      autocomplete="off"
      method="post"
      action=""
    >
      <input autocomplete="false" name="hidden" type="text" style="display:none;">
      <input type="search"/>
      <v-container>
        <v-row
          v-model="valid"
          :lazy-validation="true"
        >
          <v-col
            cols="12"
            md="6"
          >
            <date-picker
              v-model="editableObject.start"
              label="Начало подписки"
              :rules="[rules.required]"
              :error-message="(errors && errors.start)?errors.start:null"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <date-picker
              v-model="editableObject.end"
              disabled
              label="Окончание подписки"
              :rules="[rules.required]"
              :error-message="(errors && errors.end)?errors.end:null"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-if="contact && isCreation"
              v-model="editableObject.address"
              :items="contact.addresses"
              :rules="[rules.required]"
              item-value="uuid"
              item-text="formatted"
              prepend-icon="mdi-format-list-bulleted-type"
              single-line
              hint="Адрес"
              persistent-hint
              :error-messages="(errors && errors.addresses)?errors.addresses:null"
              @change="removeError('addresses')"
            ></v-select>
            <address-selector
              v-else-if="isObject(editableObject.address)"
              :disable-close="!isCreation"
              :required="addressError"
              :selected-address="editableObject.address"
              @select="editableObject.address = $event"
            />
          </v-col>
          <v-col cols="12"></v-col>
          <v-col
            v-if="!isCreation"
            cols="12"
            md="6"
          >
            <subscription-orders
              :subscription="editableObject"
            />
          </v-col>
          <v-col
            v-if="!isCreation"
            cols="12"
            md="6"
          >
            <payments-list
              :payable-type="SUBSCRIPTIONS"
              :payable="editableObject"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </edit-modal>
</template>

<script>
import isObject from 'lodash/isObject';
/* constants */
import { SUBSCRIPTIONS } from '@/constants/payable';
/* utils */
import { deepMerge, cloneObj } from '@/utils';
/* mixins */
import editModalMixin from '@/mixins/editModalMixin';
import validationMixin from '@/mixins/validationMixin';
/* components */
import EditModal from '@/components/listings/EditModal.vue';
import AddressSelector from '@/components/autocomples/AddressSelector.vue';
import SubscriptionOrders from '@/components/listings/SubscriptionOrders.vue';
import PaymentsList from '@/components/listings/PaymentsList.vue';
import DatePicker from '@/components/DatePicker.vue';


export default {
  name: 'EditModalSubscription',
  mixins: [editModalMixin, validationMixin],
  components: {
    EditModal,
    AddressSelector,
    SubscriptionOrders,
    PaymentsList,
    DatePicker,
  },
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    contact: {
      type: Object,
      default: () => {
      },
    },
    errors: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      isObject,
      SUBSCRIPTIONS,
      modalStart: false,
      modalEnd: false,
      /* validation */
      addressError: false,
      /* Data */
      initialEditableObject: {
        start: null,
        end: null,
        address: null,
      },
      editableObject: {},
    };
  },
  mounted() {
    this.initEditableObject();
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    isCreation() {
      return !(this.item && this.item.uuid);
    },
    dialogTitle() {
      return this.isCreation ? this.item.name : '';
    },
  },
  watch: {
    isShowDialog(newVal) {
      if (newVal) {
        this.initEditableObject();
        this.resetValidation();
      }
    },
    'editableObject.start': {
      handler(newVal) {
        if (newVal && !this.editableObject.end) {
          this.editableObject.end = this.editableObject.start.clone();
          this.editableObject.end.add(30, 'd');
        }
      },
      deep: true,
    },
  },
  methods: {
    initEditableObject() {
      this.editableObject = deepMerge(cloneObj(this.initialEditableObject), this.item);
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onAction() {
      if (this.isValidForm()) {
        this.$emit('on-action', this.editableObject);
      }
    },
    removeError(key) {
      if (this.errors && this.errors[key]) {
        this.errors[key] = null;
      }
    },
    isValidForm() {
      this.addressError = !(this.editableObject.address);
      return this.$refs.form.validate() && this.editableObject.address;
    },
  },
};
</script>

<style lang="sass" scoped>

</style>
